import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import styled from "styled-components";
import { colorPrimary } from "~/lib/constants";
import { generateQuestionPostPath } from "~/lib/utils/urlHelper";
import { Topic } from "~/models/topic";

interface QuestionButtonProps {
  topic?: Topic;
}

const QuestionButton: React.FC<QuestionButtonProps> = ({ topic }) => {
  const router = useRouter();
  return (
    <Link href={generateQuestionPostPath({ router, topic })} passHref>
      <QuestionLink>
        <QuestionText>質問</QuestionText>
      </QuestionLink>
    </Link>
  );
};

const QuestionLink = styled.a`
  align-items: center;
  background-color: #fff;
  border-radius: 40px;
  border: 2px solid var(--box-bdr-clr);
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  font-size: 15px;
  font-weight: var(--dark-mode-weight);
  line-height: 15px;
  height: 40px;
  justify-content: center;
  padding: 0 16px;

  &:hover {
    background-color: ${colorPrimary[300]};
  }
`;

const QuestionText = styled.span`
  color: ${colorPrimary[500]};
`;

export default QuestionButton;
